<template>
    <div>
        <div class="edit-option">
            <div><span class="title">分值说明</span><span class="desc">（最多可输入10个汉字）</span></div>
            <div class="input">
                <el-input v-model="data.explainDes" placeholder="Please input" maxlength="20" />
            </div>
        </div>
        <div class="edit-option">
            <div><span class="title">标签设置</span><span class="desc">（每行对应一个标签，最多10个标签）</span></div>
            <div class="input">
                <el-input @input="descChange" @blur="descBlur" v-model="data.tags" :rows="6" type="textarea" placeholder="请输入标签" />
            </div>
        </div>
    </div>
</template>
<script setup>
import { ref } from "vue";
const props = defineProps({
    data: {
        type: Object,
        default: {},
    },
});
let preTags = ref(""); // 存储上一个标签的值
// 判断当前tagsList是否有值
if (props.data.tagsList.length > 0) {
    props.data.tags = props.data.tagsList.join("\n");
}

const descChange = (e) => {
    // 最多输入10行
    if (getAddRow() > 10) {
        props.data.tags = preTags.value;
    } else {
        preTags.value = e;
    }
};
const descBlur = (e) => {
    // 判断是否有重复，如果重复，则需要去重

    if (props.data.tags) {
        let tagsSplit = Array.from(new Set(props.data.tags.split(/[(\r\n)\r\n]+/)));
        props.data.tags = tagsSplit.join("\n");
        preTags.value = props.data.tags;
        props.data.tagsList = tagsSplit;
    }

    // 判断最后输入得这一行是否重复，如果重复需要清除
};
function getAddRow() {
    let row = 0;
    props.data.tags.split("\n").forEach((item) => {
        if (item.length === 0) {
            row += 1;
        } else {
            row += Math.ceil(item.replace(/[\u0391-\uFFE5]/g, "aa").length / 20);
        }
    });
    return row;
}
</script>
<style lang="scss" scoped>
.edit-option {
    font-size: 14px;
    margin-bottom: 20px;
    .title {
    }
    .desc {
        color: rgba(183, 186, 191, 1);
    }
    .input {
        margin-top: 12px;
        padding-left: 26px;
    }
}
</style>
